import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

const MultiRangeSlider = ({ min, max, onChange }) => {
    console.log(min, "minmin");
    console.log(max, "maxmax");

    // Initialize state based on props for min and max values
    const [minVal, setMinVal] = useState();
    const [maxVal, setMaxVal] = useState();
console.log(minVal,"minVal")
    const minValRef = useRef(min);
    const maxValRef = useRef(max);
    const range = useRef(null);

    // Function to get the percentage for the range
    const getPercent = (value) => Math.round(((value - min) / (max - min)) * 100);

    // Synchronize state with props when min and max values change
    useEffect(() => {
        setMinVal(min);
        setMaxVal(max);
    }, [min, max]);

    // Update the range based on min and max values
    useEffect(() => {
        const minPercent = getPercent(minVal);
        const maxPercent = getPercent(maxVal);
        if (range.current) {
            range.current.style.left = `${minPercent}%`;
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [minVal, maxVal]);

    // Handler to update min value
    const handleMinChange = (event) => {
        let value = Math.min(Number(event.target.value), maxVal - 1);
        setMinVal(value);
        minValRef.current = value;
    };

    // Handler to update max value
    const handleMaxChange = (event) => {
        let value = Math.max(Number(event.target.value), minVal + 1);
        setMaxVal(value);
        maxValRef.current = value;
    };

    // Notify parent component of changes
    useEffect(() => {
        onChange({ minValue: minVal, maxValue: maxVal });
    }, [minVal, maxVal, onChange]);

    return (
        <div>
            <div className="d-block w-100 position-relative" style={{ height: '2px' }}>
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={minVal}
                    onChange={handleMinChange}
                    className="thumb thumb--left"
                    style={{ zIndex: minVal > max - 100 && "5" }}
                />
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={maxVal}
                    onChange={handleMaxChange}
                    className="thumb thumb--right"
                />

                <div className="slider">
                    <div className="slider__track" />
                    <div ref={range} className="slider__range" />
                    <div className="slider__left-value">₹{minVal}</div>
                    <div className="slider__right-value">₹{maxVal}</div>
                </div>
            </div>
        </div>
    );
};

MultiRangeSlider.propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
};

export default MultiRangeSlider;
